import React, { useEffect, useState } from 'react';
import validator from 'validator';
import { Typography } from '../typography';
import { Button } from '../button';
import { Input } from '../input';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from './ModalComponents';
import { useUpdateHoldContainerMutation } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { INPUT_ERRORS, MESSAGES } from '../../const';
import { i18n } from '../../i18n';

interface ContainerUpdateHoldModalType {
  data: {
    id: string;
    number: string;
  }[];
  isHold: boolean;
  submitClick: () => void;
  open: () => void;
}

export const containerUpdateHoldModal: ContainerUpdateHoldModalType = {
  data: [],
  isHold: false,
  submitClick: () => null,
  open: () => null,
};

export const ContainerUpdateHoldModal = () => {
  const updateHoldContainerMutation = useUpdateHoldContainerMutation();
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState<string>('');

  const validators = {
    comment: comment
      ? !validator.isLength(comment, { min: 10, max: 200 })
        ? INPUT_ERRORS.NOT_VALID.COMMENT_LENGTH
        : ''
      : '',
  };

  useEffect(() => {
    containerUpdateHoldModal.open = () => {
      setComment('');
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    containerUpdateHoldModal.data = [];
    setOpen(false);
  };

  const handleSubmitClick = async () => {
    if (validators.comment) return;

    const mutateData = {
      body: containerUpdateHoldModal.data.map((item) => ({
        id: item.id,
        ...(containerUpdateHoldModal.isHold ? { comment } : {}),
      })),
      isHold: containerUpdateHoldModal.isHold,
    };

    const onSuccess = () => {
      setOpen(false);
      containerUpdateHoldModal.submitClick();
    };

    updateHoldContainerMutation.mutate(mutateData, {
      onSuccess,
      onError: () => {
        enqueueSnackbar(MESSAGES.CONTAINERS.ERROR.NOT_EDITED, 'error');
      },
    });
  };

  return (
    <ModalBase id={'container-update-hold-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {containerUpdateHoldModal.isHold
            ? i18n.t('dropdown.holdContainer')
            : i18n.t('dropdown.releaseHold')}
        </Typography>
        <ModalBodyCustomColumns columns={'1fr'}>
          {containerUpdateHoldModal.isHold && (
            <Input
              label={i18n.t('label.comment')}
              data-size={'medium'}
              defaultValue={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
              error={validators.comment}
              helperText={validators.comment}
            />
          )}
          {containerUpdateHoldModal.data.map((item, i) => (
            <Typography key={i} variant={'textM'}>
              {item.number}
            </Typography>
          ))}
        </ModalBodyCustomColumns>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
